import script from "./index_bak.vue?vue&type=script&setup=true&lang=js"
export * from "./index_bak.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__